import { render, staticRenderFns } from "./new-note.vue?vue&type=template&id=d9b27052&"
import script from "./new-note.vue?vue&type=script&lang=js&"
export * from "./new-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports